import { useEffect } from 'react'

const DEFAULT_TITLE = 'AI-README'

/** 라우트 본문이 알게 된 시점에 document.title 을 동적으로 갱신.
 *  title 이 비어 있으면 (로딩 등) 기본값으로 폴백, unmount 시에도 기본값으로 복원. */
export function usePageTitle(title: string | undefined | null) {
  useEffect(() => {
    document.title = title ? `${title} · ${DEFAULT_TITLE}` : DEFAULT_TITLE
    return () => {
      document.title = DEFAULT_TITLE
    }
  }, [title])
}
